import { Page } from 'pages/layout'
import {
  ShiftEditorContext,
  ShiftEditorProvider,
} from 'pages/ShiftEditorPage/ShiftEditorProvider'
import { Route } from 'react-router'
import { PatchedTelemetryRoutes } from '@workwhile/telemetry/react'
import { StepIndicator } from './StepIndicator'
import { StepChecker } from './StepChecker'

export function ShiftEditorPage() {
  return (
    <ShiftEditorProvider>
      <ShiftEditorContext.Consumer>
        {(context) => {
          return (
            <Page>
              <StepIndicator />
              <PatchedTelemetryRoutes>
                {context?.steps.map((step) => (
                  <Route
                    key={step.route}
                    path={step.route}
                    element={
                      <StepChecker name={step.name}>{step.page}</StepChecker>
                    }
                  />
                ))}
              </PatchedTelemetryRoutes>
            </Page>
          )
        }}
      </ShiftEditorContext.Consumer>
    </ShiftEditorProvider>
  )
}
